export default "__VITE_ASSET__CJ6wa35j__"